module.exports = __webpack_public_path__ + "static/media/SuggestTopic.3411f57a.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SuggestTopic.jpg
// module id = 3740
// module chunks = 0